import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {AcceptorFn, AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {getMaxPowerXFlyback, getMinPower} from "./acdc__common_acceptor";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";


export class Acceptor_AcDc_Flyback extends Acceptor_Common {

  private acceptSingle_FLYBACK_Vout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single voltage output is defined and inside the bounds */
    return (Utils.isValueEmpty(out.voltage)) || ((a.vout_min <= Math.abs(out.voltage) && Math.abs(out.voltage) <= a.vout_max));
  }

  private acceptSingle_FLYBACK_Pout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single voltage output is defined and inside the bounds */

    if (Utils.isValueReal(out.voltage) && Utils.isValueReal(out.current)) {
      const singlePower = out.current * Math.abs(out.voltage);

      const minPower: number = getMinPower(a);
      const maxPower: number = getMaxPowerXFlyback(a, spec);
      return (((Utils.isValueEmpty(minPower) || minPower <= singlePower) && (Utils.isValueEmpty(maxPower) || singlePower <= maxPower)));
    } else {
      return true;
    }
  }

  private accept_FLYBACK_Pout: AcceptorFn = (a: Ic, spec: IAppSpec): boolean => {
    /* check if single voltage output is defined and inside the bounds */
    const out = spec.spec.value.output.globalOutput; // getTotalOutput(spec);

    if (Utils.isValueReal(out.voltage) && Utils.isValueReal(out.current) && out.voltage > 0 && out.current > 0) {
      const globalPower = out.power;

      const minPower: number = getMinPower(a);
      const maxPower: number = getMaxPowerXFlyback(a, spec);
      return (((Utils.isValueEmpty(minPower) || minPower <= globalPower) && (Utils.isValueEmpty(maxPower) || globalPower <= maxPower)));
    } else {
      return true;
    }
  }


  protected singleOutputV(): AcceptorOutputFn {
    return this.acceptSingle_FLYBACK_Vout;
  }

  protected singleOutputP(): AcceptorOutputFn {
    return this.acceptSingle_FLYBACK_Pout;
  }

  protected globalOutputP(): AcceptorFn {
    return this.accept_FLYBACK_Pout;
  }
}
